export default "__VITE_ASSET__DDtzrj9C__"